module.exports = __webpack_public_path__ + "img/indexbg2.a81d6d9b.png";